import styled from '@emotion/styled';
import { Alert, message, Modal, ModalProps } from 'antd';
import { useIsStoreAliasFirst } from 'hooks/business/store/useStoreName';
import useCrud from 'hooks/useCrud';
import { useEffect, useRef, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { storeMissList, StoreMissListParams } from '../service';
import MissRecordTable from './MissRecordTable';

const Content = styled.div`
  margin: -24px;
  padding: 16px;
  > .ant-alert {
    margin: -16px;
    margin-bottom: 16px;
  }
`;

export interface MissRecordModalProps extends ModalProps {
  storeSummary: AeOverview.StoreSummary;
}

function MissRecordModal(props: MissRecordModalProps) {
  const { storeSummary, ...otherProps } = props;

  const { t } = useTranslate();

  const { storeId, storeName, alias } = storeSummary;

  const isStoreAliasFirst = useIsStoreAliasFirst('ALIEXPRESS', 'GB');

  const [page, setPage] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const { loading, list, fetchList } = useCrud({
    readList: (props: StoreMissListParams) =>
      storeMissList(props).then((res) => {
        const { details, total } = res;

        const { pageNum, pageSize } = props;

        setPage({
          current: pageNum,
          pageSize,
          total,
        });

        return details;
      }),
  });

  const refsCurrent = {
    fetchList,
    t,
  };
  const refs = useRef(refsCurrent);
  refs.current = refsCurrent;

  useEffect(() => {
    refs.current
      .fetchList({
        storeId,
        pageNum: 1,
        pageSize: 10,
      })
      .catch(() => {
        message.error(refs.current.t('phrase.获取数据失败，请稍后再试'));
      });
  }, [storeId]);

  const alert = (
    <Alert
      banner
      showIcon={false}
      type="warning"
      message={t('aeoverview.仅展示店铺近60天内错失服务机会记录')}
    />
  );

  const table = (
    <MissRecordTable
      loading={loading}
      dataSource={list}
      pagination={{
        ...page,
        showSizeChanger: false,
        showTotal: (x) => t('feedback.共x项', { x }),
        onChange: (pageNum, pageSize) => {
          fetchList({
            storeId,
            pageNum,
            pageSize,
          }).catch(() => {
            message.error(t('phrase.获取数据失败，请稍后再试'));
          });
        },
      }}
    />
  );

  return (
    <Modal
      title={`${t('aeoverview.查看错失服务机会记录')}(${
        isStoreAliasFirst ? alias || storeName : storeName
      })`}
      footer={null}
      width={660}
      {...otherProps}
    >
      <Content>
        {alert}
        {table}
      </Content>
    </Modal>
  );
}

export default MissRecordModal;
